module.exports = __webpack_public_path__ + "img/VOIP-Phone-Business-Logo.12b492a0.svg";